import React from 'react';
import { Box, Heading, Text } from '@marvelapp/ui';
import PanelBox from '../PanelBox';
export default function EmptyState(_a) {
    var children = _a.children, heading = _a.heading, message = _a.message;
    return (React.createElement(PanelBox, { width: 1 },
        React.createElement(Heading, { fontSize: 14, fontWeight: 500, marginBottom: 2 }, heading),
        React.createElement(Text, { fontSize: 13 }, message),
        children && React.createElement(Box, { marginTop: 3 }, children)));
}
